export function formatItemTier(tier: number): string {
  if (!Number.isInteger(tier) || tier <= 1) return "";

  return (
    ({ 2: "II", 3: "III", 4: "IV" } as Record<number, string>)[tier] ??
    String(tier)
  );
}

export function formatItemEnhancement(enhancementLevel: number): string {
  return Number.isInteger(enhancementLevel) && enhancementLevel > 0
    ? `+${enhancementLevel}`
    : "";
}

export function formatItemProgression(
  tier: number,
  enhancementLevel = 0,
): string {
  return [formatItemTier(tier), formatItemEnhancement(enhancementLevel)]
    .filter(Boolean)
    .join(" · ");
}

export function describeItemProgression(
  tier: number,
  enhancementLevel: number,
): string[] {
  const tierLabel = formatItemTier(tier);
  const enhancementLabel = formatItemEnhancement(enhancementLevel);

  return [
    tierLabel ? `Tier ${tierLabel}` : "",
    enhancementLabel ? `Enhancement ${enhancementLabel}` : "",
  ].filter(Boolean);
}
